import heic2any from 'heic2any';
import Resizer from 'react-image-file-resizer';

const ORIGINAL_IMAGE_MAX_WIDTH = 10000;
const ORIGINAL_IMAGE_MAX_HEIGHT = 10000;
const ORIGINAL_IMAGE_FORMAT = 'JPEG';
const ORIGINAL_IMAGE_QUALITY = 100;
const THUMBNAIL_IMAGE_MAX_WIDTH = 300;
const THUMBNAIL_IMAGE_MAX_HEIGHT = 300;

/**
 * 元画像読み込み用リサイズメソッド
 * @param file File.
 */
const resizeFileForOriginal = (blob: Blob) => new Promise<Blob>((resolve) => {
  Resizer.imageFileResizer(
    blob,
    ORIGINAL_IMAGE_MAX_WIDTH,
    ORIGINAL_IMAGE_MAX_HEIGHT,
    ORIGINAL_IMAGE_FORMAT,
    ORIGINAL_IMAGE_QUALITY,
    0,
    (output) => {
      resolve(output as Blob);
    },
    'blob',
  );
});

/**
 * 画像を読み込み、既定のサイズにリサイズしてJPEGに変換
 * @param file File.
 */
export async function loadAsJpg(file: File) {
  const { name, type } = file;
  let isHeic = false;
  if (type === 'image/heic') {
    isHeic = true;
  }
  if (type === '') {
    const tmp = name.split('.');
    if (tmp[tmp.length - 1].toLowerCase() === 'heic') {
      isHeic = true;
    }
  }
  // Fileを読み込んで変換
  let blob: Blob;
  if (isHeic) {
    const heic = await heic2any({ blob: file }) as Blob;
    blob = await resizeFileForOriginal(heic);
  } else {
    blob = await resizeFileForOriginal(file);
  }
  return blob;
}

/**
 * 元画像読み込み用リサイズメソッド
 * @param file File.
 */
const resizeFileForWebp = (blob: Blob) => new Promise<Blob>((resolve) => {
  Resizer.imageFileResizer(
    blob,
    ORIGINAL_IMAGE_MAX_WIDTH,
    ORIGINAL_IMAGE_MAX_HEIGHT,
    'WEBP',
    60,
    0,
    (output) => {
      resolve(output as Blob);
    },
    'blob',
  );
});

/**
 * 画像を読み込み、既定のサイズにリサイズしてWEBPに変換
 * @param file File.
 */
export async function loadAsWebp(file: File) {
  const { name, type } = file;
  let isHeic = false;
  if (type === 'image/heic') {
    isHeic = true;
  }
  if (type === '') {
    const tmp = name.split('.');
    if (tmp[tmp.length - 1].toLowerCase() === 'heic') {
      isHeic = true;
    }
  }
  // Fileを読み込んで変換
  let blob: Blob;
  if (isHeic) {
    const heic = await heic2any({ blob: file }) as Blob;
    blob = await resizeFileForWebp(heic);
  } else {
    blob = await resizeFileForWebp(file);
  }
  return blob;
}

/**
 * Webp形式のサムネイル画像を生成.
 * @param file File.
 */
export async function generateWebpThumbnail(file: File | Blob) {
  // リサイズしてWEBPで出力
  const webpBlob = await new Promise<Blob>((resolve) => {
    Resizer.imageFileResizer(
      file,
      THUMBNAIL_IMAGE_MAX_WIDTH,
      THUMBNAIL_IMAGE_MAX_HEIGHT,
      'WEBP',
      60,
      0,
      (output) => {
        resolve(output as Blob);
      },
      'blob',
    );
  });
  return webpBlob;
}
